import { render, staticRenderFns } from "./releaseStatistics.vue?vue&type=template&id=c290fca8&scoped=true&"
import script from "./releaseStatistics.vue?vue&type=script&lang=js&"
export * from "./releaseStatistics.vue?vue&type=script&lang=js&"
import style0 from "./releaseStatistics.vue?vue&type=style&index=0&id=c290fca8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c290fca8",
  null
  
)

export default component.exports